import React from 'react';
import cn from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { bool, number, string } from 'prop-types';
import Icon from '../Icon/Icon';
import { removeDoubleSlashes } from '../../utils/utils';

const propTypes = {
  format: string.isRequired,
  url: string.isRequired,
  width: number,
  height: number,
  is_adult: bool,
  staticPath: string,
};

const defaultProps = {
  staticPath: '',
};

const CollectionListItem = ({ url, width, height, format, is_adult, staticPath }) => (
  <div className={cn('collection-list-item', format, { isAdult: is_adult })}>
    {format === 'img' && (
      <LazyLoadImage
        src={removeDoubleSlashes(`${staticPath}${url}`)}
        className="img-fluid"
        width={width}
        height={height}
        alt=""
      />
    )}

    {format === 'flash' && (
      <object width={width} height={height}>
        <param name="movie" value={removeDoubleSlashes(`${staticPath}${url}`)} />
        <param name="quality" value="high" />
        <param name="wmode" value="opaque" />
        <param name="allowFullScreen" value="false" />
        <embed
          width={width}
          height={height}
          src={removeDoubleSlashes(`${staticPath}${url}`)}
          type="application/x-shockwave-flash"
          wmode="opaque"
          quality="high"
        />
      </object>
    )}

    <a
      href={removeDoubleSlashes(`${staticPath}${url}`)}
      aria-label="Download"
      className="collection-list-item-download"
      target="_blank"
      download
    >
      <Icon type="download" />
    </a>
  </div>
);

CollectionListItem.propTypes = propTypes;
CollectionListItem.defaultProps = defaultProps;

export default CollectionListItem;
